import { type Theme } from '@mui/material';
import { type SystemStyleObject } from '@mui/system';
import { type ScreenType } from '@tmdb-graphql-api/schema/types';
import { type BbfcCertification } from '#enums/certifications.ts';
import { Bbfc12, Bbfc12A, Bbfc15, Bbfc18, BbfcPG, BbfcR18, BbfcU } from '../icons/certifications/index.ts';

const icons = {
  '12': Bbfc12,
  '12A': Bbfc12A,
  '15': Bbfc15,
  '18': Bbfc18,
  PG: BbfcPG,
  R18: BbfcR18,
  U: BbfcU,
};

export type ComponentProps = {
  certification: BbfcCertification;
  height?: number;
  id: string | number;
  sx?: SystemStyleObject<Theme>;
  type: ScreenType;
  width?: number;
};

export const Component = ({ certification, height, id, sx, type, width }: ComponentProps) => {
  const Icon = icons[certification];

  // It is possible to otherHelpers an edge case where the certification to be undefined
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!Icon) {
    console.error(`Invalid certification. Certificate "${certification}" received for ${type} "${String(id)}"`);
    return;
  }

  return <Icon height={height} sx={sx} width={width} />;
};
